module.exports = __webpack_public_path__ + "static/media/rahul.a4dcc780.svg";